import CustomModal from "../../Common/CustomModal";
import AvatarCropModal from "../AvatarCropModal";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import { useAvatarCrop } from "../../../hooks/useAvatarCrop";
import { Gapper } from "../../ui/Gapper";
import { InfoText, ContentBox } from "../shared/practitionerForm.styles";
import {
  MODAL_TITLE,
  SAVE_BTN_TEXT,
  CANCEL_BTN_TEXT,
  SUBMIT_DISCLAIMER,
  UPDATES_DISCLAIMER,
} from "./IPHCPractitionerModal.constants";
import { isFormEmpty } from "../shared/practitionerForm.utils";
import PractitionerStatusSection from "./components/PractitionerStatusSection";
import BioAndSpecialtiesSection from "../shared/components/BioAndSpecialtiesSection";
import WebsiteAndSocialsSection from "../shared/components/WebsiteAndSocialsSection";
import ContactInfoSection from "../shared/components/ContactInfoSection";
import ComplianceDocumentsSection from "./components/ComplianceDocumentsSection";
import PhysicalOfficeSection from "./components/PhysicalOfficeSection";
import PreferencesSection from "./components/PreferencesSection";

const IPHCPractitionerModal = ({
  open,
  handleClose,
  submitData,
  setSubmitData,
  handleSubmit,
  handleImageUpload,
  handleFileChange,
  handleFileDelete,
  setErrorState,
  autoSaveStatus,
  loading,
}) => {
  const { iphcPractitioner } = useSelector((state) => state.user);
  const theme = useTheme();
  const isMediumScreen = useMediaQuery(theme.breakpoints.down(900));

  // Approval status now comes straight from the DB record (no GoHighLevel call).
  const practitionerStatus = !!iphcPractitioner?.practitionerStatus;

  const avatarCrop = useAvatarCrop(
    handleImageUpload,
    submitData?.avatar,
    setErrorState
  );

  const updateField = (name, value) => {
    setSubmitData((prev) => ({ ...prev, [name]: value }));
  };

  const handleModifiedSubmit = async () => {
    const modifiedData = {
      ...submitData,
      emergencyPlanAck: "",
    };

    const success = await handleSubmit(modifiedData);
    if (success) {
      handleClose();
    }
  };

  return (
    <>
      <CustomModal
        open={open}
        handleClose={handleClose}
        title={MODAL_TITLE}
        width={isMediumScreen ? "98%" : "75%"}
        saveBtnText={loading ? "Saving..." : SAVE_BTN_TEXT}
        cancelBtnText={CANCEL_BTN_TEXT}
        disableBtn={isFormEmpty(submitData) || loading}
        onSave={handleModifiedSubmit}
        onCancel={handleClose}
      >
        <Box>
          <InfoText>{SUBMIT_DISCLAIMER}</InfoText>
          <InfoText>{UPDATES_DISCLAIMER}</InfoText>
        </Box>
        <PractitionerStatusSection
          practitionerStatus={practitionerStatus}
          autoSaveStatus={autoSaveStatus}
        />
        <ContentBox>
          <Gapper gap={0}>
            <BioAndSpecialtiesSection
              submitData={submitData}
              updateField={updateField}
              avatarSectionProps={{
                avatar: submitData?.avatar,
                avatarLoading: avatarCrop.avatarLoading,
                onFileSelect: avatarCrop.handleAvatarFileSelect,
                onImageLoad: () => avatarCrop.setAvatarLoading(false),
                onImageError: () => avatarCrop.setAvatarLoading(false),
              }}
            />
            <WebsiteAndSocialsSection
              submitData={submitData}
              updateField={updateField}
            />
            <ContactInfoSection
              submitData={submitData}
              updateField={updateField}
            />
            <ComplianceDocumentsSection
              submitData={submitData}
              updateField={updateField}
              handleFileChange={handleFileChange}
              handleFileDelete={handleFileDelete}
            />
            <PhysicalOfficeSection
              submitData={submitData}
              updateField={updateField}
              handleFileChange={handleFileChange}
              handleFileDelete={handleFileDelete}
            />
            <PreferencesSection
              submitData={submitData}
              updateField={updateField}
            />
          </Gapper>
        </ContentBox>
      </CustomModal>
      <AvatarCropModal
        open={avatarCrop.avatarCropOpen}
        image={avatarCrop.avatarCropImage}
        onConfirm={avatarCrop.handleAvatarCropConfirm}
        onCancel={avatarCrop.avatarCropCancel}
      />
    </>
  );
};

export default IPHCPractitionerModal;
